const selectStyle = Object.freeze({
  borderWidth: 1,
  lines: 0,
  borderStyle: 'solid',
  verticalPaddingButton: '1rem',
});

export default selectStyle;
